export enum TicketPartnerStatus {
  PRIVATE = 'PRIVATE',
  BUSINESS = 'BUSINESS',
  PRIVATE_BUSINESS = 'PRIVATE_BUSINESS',
  REGISTERED = 'REGISTERED',
}
